import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import * as Actions from '../actions';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import lang from '../constants/Languages.js';
import { isPristine } from 'redux-form';

//import components
import PageHeader from '../components/PageHeader.js';
import LoadingIndicatorText from '../components/LoadingIndicatorText.js';
import WrongQueryError from '../components/simple-search-results/WrongQueryError.js';
import SimpleSearchResultsTabContent from '../components/simple-search-results/SimpleSearchResultsTabContent.js';
import LoadingError from '../components/LoadingError.js';
import SimpleSearchResultsTab from '../components/simple-search-results/SimpleSearchResultsTab.js';
import SearchInfo from '../components/search/SearchInfo.js';
import SearchInfoAdvanced from '../components/search/SearchInfoAdvanced.js';
import SearchCount from '../components/search/SearchCount.js';
import ItemBreadcrumbs from '../components/items/ItemBreadcrumbs.js';
import NoSearchResults from '../components/simple-search-results/NoSearchResults.js';
import ChangeQuery from '../components/advanced-search/ChangeQuery.js';
import DetailsDescResults from '../components/characteristics-details/DetailsDescResults.js';
import DetailsDescSwitches from '../components/characteristics-details/DetailsDescSwitches.js';
import DownloadFormats from '../components/formats-to-download/DownloadFormats';

//helper scripts
import * as ValidateQuery from '../scripts/ResultsQueryValidation.js';
import * as BuildQuery from '../scripts/ResultsFiltersQueryBuild.js';
import ParseQuery from '../scripts/ResultsQueryParse.js';
import * as CheckPathname from '../scripts/CheckPathname.js';
import withTitle from '../scripts/WithTitle.js';
import SearchOptionsAdvanced from '../scripts/SearchOptionsAdvanced.js';

class SimpleSearchResults extends Component {

	componentDidMount() {
		const { location } = this.props;
		const query = queryString.parse(location.search, { arrayFormat: 'index' });

		this.updateResultsPage(query);
	};

	componentDidUpdate(prevProps) {
		const { applyFilters, tabs, location, actions, applyHeadingFilters, clang } = this.props;
		// const { applyFilters, tabs, location, actions, applyHeadingFilters, appliedFilters, clang, isBlocked } = this.props;
		const query = queryString.parse(location.search, { arrayFormat: 'index' });
		const prevQuery = queryString.parse(prevProps.location.search, { arrayFormat: 'index' });

		if (applyFilters) {
			const activeTabName = applyHeadingFilters ? false : tabs.filter(tab => tab.active)[ 0 ].name
			actions.resetApplyFilter();
			this.updateResultsList(activeTabName, null, null, 1);
		}

		if (prevProps.location !== location || clang !== prevProps.clang) {
			this.updateResultsPage(query);
		}

		if (prevProps.location !== location) {
			window.scrollTo(0, 0);
		}

		if (CheckPathname.isRecordsSearch(location) && ((prevQuery.RECORD_FORM && !query.RECORD_FORM) || (!prevQuery.RECORD_FORM && query.RECORD_FORM))) {
			actions.resetIsBlocked();
			actions.resetFilters();
		}
	};

	componentWillUnmount() {
		const { actions } = this.props;
		actions.resetFilters();
		actions.resetIsBlocked();
		actions.resetTabNav();
		actions.resetSearchKey();
		actions.resetApiAddress();
		actions.resetCsvAddress();
	};

	// *****UPDATE LIST OF RESULTS WITH AVAILABLE FILTERS*****

	updateResultsPage = (query) => {
		const { actions, searchOptionsFiles, searchOptions, searchOptionsAdvanced, ipp, location } = this.props;
		const isAllFiles = CheckPathname.isFilesSearch(location);
		const isLoggedIn = localStorage.getItem('user');
		const newOptions = [ ...searchOptions, ...searchOptionsAdvanced ].filter(option => !(!isLoggedIn && option.logged));

		//add validation for filters
		if (ValidateQuery.isValidQuery(query, newOptions, searchOptionsFiles, isAllFiles)) {
			const isHeadingsDetails = CheckPathname.isHeadingsDetails(location);
			const isAdvancedSearchResults = CheckPathname.isAdvancedSearchResults(location);

			//load results with initial search params from url
			actions.fetchSimpleSearchResults({
				key: query.q.trim(),
				area: query.area.trim(),
				tab: query.tab ? query.tab.trim() : false,
				ipp: query.ipp && ipp.filter(item => item.val === parseInt(query.ipp.trim(), 10)).length > 0 ? query.ipp.trim() : ipp[ 0 ].val,
				page: query.page ? query.page.trim() : 1,
				sorting: query.sorting ? query.sorting.trim() : false,
				filters: ParseQuery({ ...query }, isAdvancedSearchResults),
				isHeadingsDetails: isHeadingsDetails,
				isAdvancedSearchResults: isAdvancedSearchResults
			});
		} else {
			//display error when query from url is invalid
			actions.simpleSearchWrongQueryError();
		}
	};

	// *****UPDATE LIST OF RESULTS*****

	updateResultsList = (name, ipp, sorting, pageNum) => {
		const { searchParams, history, appliedFilters, tabNav, location, headingFilters, headingFiltersSelect, headingId } = this.props;
		const isHeadingsDetails = CheckPathname.isHeadingsDetails(location);
		const isAdvancedSearchResults = CheckPathname.isAdvancedSearchResults(location);

		const filters = isHeadingsDetails ?
			BuildQuery.buildQueryHeadingsDetails(name, appliedFilters, headingFilters, headingFiltersSelect, headingId)
			: BuildQuery.buildQuery(name, appliedFilters);

		const activeTabNav = tabNav.filter(tab => tab.name === name)[ 0 ];

		const activeTabIpp = activeTabNav ? activeTabNav.options.filter(option => option.type === 'ipp')[ 0 ] : false;
		const activeTabIppVal = activeTabIpp ? activeTabIpp.value : false;

		const activeTabSorting = activeTabNav ? activeTabNav.options.filter(option => option.type === 'sorting')[ 0 ] : false;
		const activeTabSortingVal = activeTabSorting ? activeTabSorting.value : false;

		const activeTabPage = activeTabNav ? activeTabNav.options.filter(option => option.type === 'page')[ 0 ] : false;
		const activeTabPageVal = activeTabPage ? activeTabPage.value : false;

		const newSearch = isAdvancedSearchResults ?
			`${`area=${searchParams.area}`}` +
			`&q=${searchParams.key}` +
			`${pageNum || activeTabPageVal ? `&page=${pageNum || activeTabPageVal}` : ''}` +
			`${ipp || activeTabIppVal ? `&ipp=${ipp || activeTabIppVal}` : ''}` +
			`${sorting || activeTabSortingVal ? `&sorting=${sorting || activeTabSortingVal}` : ''}` +
			`${filters}`
			: `?q=${searchParams.key}` +
			`${name ? `&area=${searchParams.area}` : '&area=all'}` +
			`${name ? `&tab=${name}` : ''}` +
			// `&tab=${applyHeadingFilters ? 'all' : name}` +
			`${pageNum || activeTabPageVal ? `&page=${pageNum || activeTabPageVal}` : ''}` +
			`${ipp || activeTabIppVal ? `&ipp=${ipp || activeTabIppVal}` : ''}` +
			`${sorting || activeTabSortingVal ? `&sorting=${sorting || activeTabSortingVal}` : ''}` +
			`${filters}`;

		history.push({
			search: newSearch
		});
	};

	updateResultsListParams = (name, ipp, sorting, pageNum) => {
		const { actions } = this.props;

		actions.setTabNav(
			name,
			[
				{ value: ipp, type: 'ipp' },
				{ value: sorting, type: 'sorting' },
				{ value: pageNum, type: 'page' },
			].filter(option => option.value)
		);

		this.updateResultsList(name, ipp, sorting, pageNum);
	};

	setActiveTab = (name) => {
		// return (btn.options && btn.options.filter(option => option.selected).length > 0);

		// this.updateHeadingFilters
		this.updateResultsList(name);
	};

	// *****FILTERS*****

	setFilter = (fieldName, id) => {
		const { actions } = this.props;
		actions.setFilter(fieldName, id);
	};

	loadFilterByName = (fieldName, key) => {
		const { actions, tabs } = this.props;
		const activeTab = tabs.filter(tab => tab.active)[ 0 ];

		actions.loadFilterByName(fieldName, key, activeTab.name);
	};

	loadAllFiltersByName = (fieldName) => {
		const { actions, tabs } = this.props;
		const activeTab = tabs.filter(tab => tab.active)[ 0 ];

		actions.loadAllFiltersByName(fieldName, activeTab.name);
	};

	cleanAllFilters = () => {
		const { actions, location } = this.props;
		const isHeadingsDetails = CheckPathname.isHeadingsDetails(location);

		if (isHeadingsDetails) {
			actions.cleanAllFiltersHeadings();
		} else {
			actions.cleanAllFilters();
		}
	};

	removeFilter = (optionId, field) => {
		const { actions, tabs } = this.props;
		const activeTab = tabs.filter(tab => tab.active)[ 0 ];

		actions.removeFilter(optionId, field, activeTab.name);
	};

	applyFilter = (id) => {
		const { actions } = this.props;
		actions.applyFilter(id);
	};

	expandTree = (id, isExpansible) => {
		const { actions } = this.props;

		if (isExpansible) {
			actions.expandTree(id, isExpansible);
		}
	};

	isFieldsOpen = (isOpened) => {
		const { actions } = this.props;
		actions.isFieldsOpen(isOpened);
	};

	setIsBlocked = (val) => {
		const { actions } = this.props;
		actions.setIsBlocked(val);
	};

	updateHeadingFilters = (name) => {
		const { actions } = this.props;
		actions.updateHeadingFilters(name);
	};

	updateHeadingFiltersSelect = (value, name) => {
		const { actions } = this.props;
		actions.updateHeadingFiltersSelect(value, name);
	};

	updateHeadingFiltersSelectRelated = (value, name) => {
		const { actions } = this.props;
		actions.updateHeadingFiltersSelectRelated(value, name);
	};

	render() {
		const { isLoading, isLoadingError, clang, isWrongQuery, queryKey, tabs, ipp, searchParams,
			appliedFilters, isMobileSmall, location, applyFilters, isBlocked, isAdvancedFormPristine,
			dictionary, headingFilters } = this.props;

		const isLoggedIn = localStorage.getItem('user');

		const activeTab = tabs.filter(tab => tab.active)[ 0 ];
		const commonFilters = appliedFilters ? appliedFilters.filter(filter => filter.type === 'COMMON_ID') : false;
		const breadcrumbsList = [ { label: 'home' }, { label: 'cards', link: '/files' } ];
		const isAllFiles = CheckPathname.isFilesSearch(location);
		const isHeadingsDetails = CheckPathname.isHeadingsDetails(location);
		const isAdvancedSearchResults = CheckPathname.isAdvancedSearchResults(location);
		const isAllRecords = CheckPathname.isRecordsSearch(location) && searchParams.key === '*';

		return (
			<section className={ `${isAdvancedSearchResults ? 'advanced-search-results' : ''} results` }>
				{ isAllFiles &&
					<ItemBreadcrumbs list={ breadcrumbsList } currentPage={ lang[ clang ].headers.files[ searchParams.area ] } /> }

				{ !isWrongQuery && !isAllFiles && !isHeadingsDetails && !isAdvancedSearchResults && !isLoadingError &&
					<PageHeader name={ lang[ clang ].headers.full_results } /> }

				{ !isWrongQuery && !isAllFiles && !isHeadingsDetails && isAdvancedSearchResults && !isLoadingError &&
					<PageHeader name={ lang[ clang ].headers.advanced_search_results } /> }

				{ !isWrongQuery && isAllFiles && <PageHeader type={ searchParams.area } name={ lang[ clang ].headers.files[ searchParams.area ] } /> }

				{ isHeadingsDetails &&
					<DetailsDescResults
						headingFilters={ headingFilters }
						isLoading={ isLoading }
						applyFilterRelated={ this.updateHeadingFiltersSelectRelated }
						applyFilter={ this.updateHeadingFiltersSelect } /> }

				{ isHeadingsDetails && !isLoading &&
					<DetailsDescSwitches
						headingFilters={ headingFilters }
						updateHeadingFilters={ this.updateHeadingFilters } /> }

				<div className="results__inner">

					{ !isWrongQuery && !isLoading && !isLoadingError &&
						<div className="results__main">
							{ !isWrongQuery && !isLoadingError && !isAdvancedSearchResults &&
								<div className="results__inner__info">
									{ !isAllFiles && !isAllRecords && !isHeadingsDetails &&
										<SearchInfo queryKey={ searchParams.key || queryKey } commonFilters={ commonFilters } /> }
									{ isAllFiles && activeTab && <SearchCount count={ activeTab.count } /> }
									<DownloadFormats lang={ lang }/>
								</div> }

							{ !isWrongQuery && !isLoadingError && isAdvancedSearchResults && activeTab &&
								<div className="results__inner__info">
									<SearchInfoAdvanced queryKey={ searchParams.key || queryKey } dictionary={ dictionary } />
									{ !isAdvancedFormPristine && <ChangeQuery /> }
									<DownloadFormats lang={ lang }/>
								</div> }

							{/* tabs */ }
							{ !isAllFiles && activeTab &&
								<ul className="results__tabs">
									{ tabs.map((tab, index) =>
										((tab.name === searchParams.area || searchParams.area === 'all') && !(isHeadingsDetails && tab.count === 0)) ?
											<SimpleSearchResultsTab
												{ ...tab }
												key={ index }
												id={ index }
												resetHeadingFilters
												setActiveTab={ this.setActiveTab }
												isMobileSmall={ isMobileSmall } />
											: null) }
								</ul> }

							{ activeTab &&
								<div className="results__content">
									<SimpleSearchResultsTabContent
										{ ...activeTab }
										isLoggedIn={ isLoggedIn }
										appliedFilters={ appliedFilters }
										isAdvancedSearchResults={ isAdvancedSearchResults }
										isMobile={ isMobileSmall }
										ipp={ ipp }
										isHeadingsDetails={ isHeadingsDetails }
										updateResultsListParams={ this.updateResultsListParams }
										applyFilters={ applyFilters }
										setFilter={ this.setFilter }
										loadFilterByName={ this.loadFilterByName }
										loadAllFiltersByName={ this.loadAllFiltersByName }
										cleanAllFilters={ this.cleanAllFilters }
										removeFilter={ this.removeFilter }
										applyFilter={ this.applyFilter }
										isBlocked={ isBlocked }
										expandTree={ this.expandTree }
										setIsBlocked={ this.setIsBlocked }
										isFieldsOpen={ this.isFieldsOpen } />
								</div> }
						</div> }

					{/* wrong query */ }
					{ isWrongQuery &&
						<WrongQueryError /> }

					{ !isWrongQuery && !isLoadingError && !isLoading && !activeTab &&
						<div className="results__no-results--container">
							<NoSearchResults isHeadingsDetails={ isHeadingsDetails } />
						</div> }

					{ !isWrongQuery && !isLoadingError && isLoading &&
						<div className="results__loader">
							<div className="results__loader--inner">
								<LoadingIndicatorText />
							</div>
						</div> }

					{ !isWrongQuery && !isLoading && isLoadingError &&
						<LoadingError /> }
				</div>
			</section>
		);
	};
};

SimpleSearchResults.propTypes = {
	clang: propTypes.string.isRequired,
	actions: propTypes.object.isRequired,
	dictionary: propTypes.object.isRequired,
	queryKey: propTypes.string.isRequired,
	searchParams: propTypes.object.isRequired,
	isLoading: propTypes.bool.isRequired,
	isLoadingError: propTypes.bool.isRequired,
	applyFilters: propTypes.bool.isRequired,
	tabs: propTypes.arrayOf(
		propTypes.shape({
			name: propTypes.string.isRequired,
			count: propTypes.number.isRequired,
			active: propTypes.bool.isRequired,
			page: propTypes.number,
			perPage: propTypes.number,
			sorting: propTypes.string,
		})
	),
	ipp: propTypes.arrayOf(
		propTypes.shape({
			val: propTypes.number.isRequired,
		})
	),
	appliedFilters: propTypes.arrayOf(
		propTypes.shape({
			id: propTypes.string.isRequired,
			label: propTypes.string.isRequired,
			value: propTypes.array,
			tab: propTypes.string
		})
	),
	tabNav: propTypes.arrayOf(
		propTypes.shape({
			name: propTypes.string.isRequired,
			options: propTypes.array.isRequired
		})
	),
	results: propTypes.arrayOf(
		propTypes.shape({
			type: propTypes.string.isRequired,
			where: propTypes.array,
			linkedText: propTypes.shape({
				id: propTypes.string.isRequired,
				link: propTypes.string,
				label: propTypes.string.isRequired
			}).isRequired,
			annotations: propTypes.string
		})
	),
	searchOptions: propTypes.arrayOf(
		propTypes.shape({
			id: propTypes.number,
			name: propTypes.string
		})
	),
	searchOptionsFiles: propTypes.arrayOf(
		propTypes.shape({
			id: propTypes.number,
			name: propTypes.string
		})
	),
	headingFilters: propTypes.arrayOf(
		propTypes.shape({
			type: propTypes.string,
			name: propTypes.string
		})
	),
	headingFiltersSelect: propTypes.arrayOf(
		propTypes.shape({
			type: propTypes.string,
			name: propTypes.string
		})
	),
	isWrongQuery: propTypes.bool.isRequired,
	isBlocked: propTypes.bool.isRequired,
};

const mapStateToProps = state => ({
	clang: state.language.currentLanguage,
	searchOptions: state.search.searchOptions,
	searchOptionsAdvanced: state.advancedSearch.tabs,
	searchOptionsFiles: state.search.searchOptionsFiles,
	isBlocked: state.simpleSearchResults.isBlocked,
	queryKey: state.simpleSearchResults.queryKey,
	searchParams: state.search.searchParams,
	tabs: state.simpleSearchResults.tabs,
	results: state.simpleSearchResults.resultsList,
	isLoading: state.simpleSearchResults.isFetching,
	isLoadingError: state.simpleSearchResults.isLoadingError,
	isWrongQuery: state.simpleSearchResults.isWrongQuery,
	ipp: state.simpleSearchResults.ipp,
	applyFilters: state.simpleSearchResults.applyFilters,
	applyHeadingFilters: state.simpleSearchResults.applyHeadingFilters,
	appliedFilters: state.simpleSearchResults.appliedFilters,
	tabNav: state.simpleSearchResults.tabNav,
	dictionary: state.language.dictionary,
	headingFilters: state.simpleSearchResults.headingFilters,
	headingId: state.simpleSearchResults.headingId,
	headingFiltersSelect: state.simpleSearchResults.headingFiltersSelect,
	detailsData: state.headingDetails.detailsData,
	isAdvancedFormPristine: SearchOptionsAdvanced.map(option => isPristine(`advanced-search-${option.name}`)(state)).reduce((sum, next) => sum && next, true)
});

const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators(Actions, dispatch)
});


const enhance = compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
	withTitle,
);

export default enhance(SimpleSearchResults);



// WEBPACK FOOTER //
// ./src/containers/SimpleSearchResults.js